import script from "./ScanPrint.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScanPrint.vue?vue&type=script&setup=true&lang=ts"

import "./ScanPrint.vue?vue&type=style&index=0&id=1dd3c52e&lang=scss&scoped=true"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dd3c52e"]])

export default __exports__